export default {
  wm: {
    commons: {
      clear: "清空",
      name: "名称",
      comments: "注释",
      please_select: "请选择",
      cut: "剪切",
      copy: "复制",
      paste: "粘贴",
      duplicate: "复写",
      enable: "启用",
      disable: "禁用",
      add: "添加",
      remove: "删除",
      insert: "插入上级",
      yes: "是",
      no: "否",
    },
    assertions: {
      label: "断言",
      response_assertion: {
        label: "响应断言",
        scope: "应用范围",
        all: "主样本和子样本",
        main: "主样本",
        children: "子样本",
        variable: "Jmeter变量",
        test_field: "检查字段",
        sample_label: "URL样本",
        response_data: "响应文本",
        response_code: "响应码",
        response_message: "响应消息",
        response_headers: "响应头",
        request_data: "请求数据",
        request_headers: "请求头",
        document: "文档(文本)",
        ignore_status: "忽略状态",
        ignore_status_desc: "选中“忽略状态”复选框时，将在评估“断言”之前将“响应”状态强制为成功。通常HTTP响应在4xx和5xx范围内的被视为不成功，“忽略状态”复选框可用于将状态设置为成功。请注意，这将清除所有先前的断言失败，因此请确保仅在第一个断言上设置此项。",
        test_type: "模式匹配规则",
        contains: "包括",
        match: "匹配",
        equals: "相等",
        substring: "子字符串",
        not: "非",
        or: "或",
        string: "内容",
        message: "自定义失败消息"
      },
      duration_assertion: {
        label: "持续时间断言",
        scope: "应用范围",
        all: "主样本和子样本",
        main: "主样本",
        children: "子样本",
        duration: "持续时间（毫秒）",
      },
      json_assertion: {
        label: "JSON断言",
        json_path: "断言JSON路径存在",
        json_validation: "附加断言值",
        is_regex: "匹配为正则表达式",
        expected_value: "期望值",
        expect_null: "期望为null",
        invert: "反转断言（如果满足以上条件，将失败）"
      }
    },
    configurations: {
      label: "配置元件",
      csv_data_set: {
        scope: "Configure the CSV Data Source",
        label: "CSV Data Set Config",
        title: "CSV Data Set Config",
        name: "名称",
        value: "值",
        filename: "Filename",
        file_encoding: "File encoding",
        variable_names: "Variable Names (comma-delimited)",
        ignore_first_line: "Ignore first line (only used if Variable Names is not empty)",
        delimiter: "Delimiter (use '\\\\t' for tab)",
        quoted_data: "Allow quoted data?",
        recycle: "Recycle on EOF ?",
        stop_thread: "Stop thread on EOF ?",
        share_mode: "Sharing mode",
      },
      arguments: {
        label: "变量管理器",
        title: "自定义变量",
        name: "名称",
        value: "值",
        desc: "描述",
      },
      header_manager: {
        label: "请求头管理器",
        title: "发送参数",
        name: "名称",
        value: "值",
      },
      cache_manager: {
        label: "Http Cache Manager",
        clear_cache_per_iter: "Clear cache each iteration?",
        cache_clear_controlled_by_threadgroup: "Use Thread Group configuration to control cache clearing",
        use_expires: "Use Cache-Control/Expires header when processing GET requests",
        cache_manager_size: "Max Number of elements in cache",
      },
      cookie_manager: {
        label: "Cookie管理器",
        options: "选项",
        clear: "每次迭代清除Cookie",
        control: "使用线程组的配置控制Cookie清理",
        policy: "Cookie 策略",
        cookies: "自定义Cookie",
        name: "名称",
        value: "值",
        domain: "域名",
        path: "路径",
        secure: "安全",
      },
      dns_cache_manager: {
        label: "DNS缓存管理器",
        options: "选项",
        clear: "每次迭代清除Cookie",
        system: "使用系统DNS",
        custom: "使用自定义DNS",
        servers: "DNS服务器",
        server: "主机名称或IP",
        hosts: "静态主机列表",
        host: "主机",
        address: "主机名称或IP",
      },
      jdbc_data_source: {
        label: "JDBC连接配置",
        data_source: "连接池名称",
        data_source_desc: "创建连接池名称，JDBC取样器可以选择这里定义的名称",
        pool_config: "连接池配置",
        pool_max: "最大连接数",
        timeout: "最大等待时间（毫秒）",
        trim_interval: "空闲连接的有效时间(毫秒)",
        auto_commit: "自动提交",
        transaction_isolation: "事务隔离级别",
        pre_init: "预初始化池",
        init_query: "初始化SQL语句，用新行分隔",
        validation_pool: "连接池验证",
        keep_alive: "闲置测试",
        connection_age: "连接空闲时间",
        check_query: "验证查询语句",
        db_config: "数据库连接配置",
        db_url: "数据库URL",
        driver: "数据库驱动",
        username: "用户名",
        password: "密码",
        connection_properties: "连接属性",
        variable: "变量"
      }
    },
    controllers: {
      label: "控制器",
      if: {
        label: "条件控制器",
        expression: "表达式",
        expressionDesc: "表达式的结果必须为true或false",
        template: "表达式模板",
        useExpression: "将条件解释为变量表达式",
        evaluateAll: "对所有孩子生效",
        eq: "等于",
        ne: "不等于",
        gt: "大于",
        lt: "小于",
        like: "包含",
        notLike: "不包含",
        empty: "空",
        notEmpty: "非空",
        name: "变量名",
        value: "值"
      },
      transaction: {
        label: "事务控制器",
        parent: "Generate parent sample",
        includeTimers: "Include duration of timer and pre-post processors in generated sample"
      }
    },
    listeners: {
      label: "监听器",
      backend: {
        label: "后端监听器",
      }
    },
    post_processors: {
      label: "后置处理器",
      regex_extractor: {
        label: "正则提取器",
        scope: "应用范围",
        all: "主样本和子样本",
        main: "主样本",
        children: "子样本",
        variable: "Jmeter变量",
        test_field: "检查字段",
        response_data: "响应文本",
        unescaped: "响应文本(未转义)",
        as_document: "文档(文本)",
        response_headers: "响应头",
        request_headers: "请求头",
        url: "URL",
        response_code: "响应码",
        response_message: "响应消息",
        ref_name: "变量名称",
        regex: "正则表达式",
        template: "模板",
        match_number: "匹配数字(0代表随机)",
        default: "默认值",
        default_empty: "使用空默认值",
      },
      json_processor: {
        label: "JSON提取器",
        scope: "应用范围",
        all: "主样本和子样本",
        main: "主样本",
        children: "子样本",
        variable: "Jmeter变量",
        ref_name: "变量名称",
        expression: "JSON Path表达式",
        match_number: "匹配数字(0代表随机)",
        default: "默认值",
        concat: "计算串联变量",
        concat_desc: "如果找到多个结果，将使用逗号 , 分隔符将它们连接起来，并将其存储在名为 变量名称_ALL 的变量中"
      },
      xpath2_extractor: {
        label: "XPath提取器",
        scope: "应用范围",
        all: "主样本和子样本",
        main: "主样本",
        children: "子样本",
        variable: "Jmeter变量",
        ref_name: "变量名称",
        xpath_query: "XPath表达式",
        match_number: "匹配数字(0代表随机)",
        default: "默认值",
        namespaces: "命名空间别名列表",
        namespaces_desc: "用来解析文档的名称空间别名列表，每个声明一行。按以下方式指定它们：prefix = namespace。",
        fragment: "返回整个XPath片段而不是文本内容"
      },
      jsr223_post_processor: {
        label: "脚本提取器",
        script_set: "脚本设置",
        script_language: "脚本语言",
        language: "语言",
        language_desc: "javascript有性能问题，不建议使用",
        parameters: "参数",
        parameters_desc: "传递给脚本的参数。Parameters - 包含参数作为单个变量的字符串; args - 包含参数的字符串数组，空格分割",
        filename: "脚本文件",
        filename_desc: "脚本文件会覆盖自定义脚本",
        cache: "脚本编译缓存",
        cache_desc: "如果语言支持Compilable接口，则缓存脚本编译的结果（Groovy是其中之一，而Java，beanshell和javascript不支持）",
        script: "自定义脚本",
      }
    },
    pre_processors: {
      label: "前置处理器",
      jsr223_pre_processor: {
        label: "脚本预处理器",
        script_set: "脚本设置",
        script_language: "脚本语言",
        language: "语言",
        language_desc: "javascript有性能问题，不建议使用",
        parameters: "参数",
        parameters_desc: "传递给脚本的参数。Parameters - 包含参数作为单个变量的字符串; args - 包含参数的字符串数组，空格分割",
        filename: "脚本文件",
        filename_desc: "脚本文件会覆盖自定义脚本",
        cache: "脚本编译缓存",
        cache_desc: "如果语言支持Compilable接口，则缓存脚本编译的结果（Groovy是其中之一，而Java，beanshell和javascript不支持）",
        script: "自定义脚本",
      }
    },
    samplers: {
      label: "取样器",
      http: {
        label: "HTTP取样器",
        basic: "基础",
        advanced: "高级",
        web_server: "Web服务器",
        protocol: "协议",
        domain: "服务器名称或IP",
        port: "端口号",
        http_request: "HTTP请求",
        method: "方法",
        path: "路径",
        content_encoding: "内容编码",
        auto_redirects: "自动重定向",
        follow_redirects: "跟随重定向",
        use_keepalive: "使用Keepalive",
        do_multipart_post: "POST使用multipart/form-data",
        browser: "与浏览器兼容的头",
        arguments: "参数",
        body: "消息体",
        file: "文件上传",
        file_path: "文件路径",
        param_name: "变量名称",
        timeout: "超时（毫秒）",
        connect: "连接",
        response: "响应",
        send_arguments: "发送参数",
        name: "名称",
        value: "值",
        encode: "编码",
        content_type: "内容类型",
        use_equals: "包含等于"
      },
      tcp: {
        label: "TCP取样器",
        classname: "TCPClient",
        target_server: "目标服务器",
        server: "服务器名称或IP",
        port: "端口",
        timeout: "超时时间（毫秒）",
        connect: "连接",
        response: "响应",
        re_use: "重用连接",
        close: "关闭连接",
        no_delay: "无延迟",
        so_linger: "SO_LINGER",
        eol_byte: "行尾(EOL)字节值",
        request: "发送内容",
        login: "登录设置",
        username: "用户名",
        password: "密码",
      },
      jdbc: {
        label: "JDBC取样器",
        data_source: "连接池名称",
        data_source_desc: "JDBC连接配置中定义的连接池名称",
        sql_query: "SQL查询",
        query: "查询",
        query_type: "查询类型",
        query_arguments: "参数值",
        query_arguments_types: "参数类型",
        query_timeout: "查询超时(秒)",
        result_set_handler: "结果集处理方式",
        result_set_max_rows: "最大返回行数",
        result_variable: "结果变量名称",
        variable_names: "变量名称",
      }
    },
    timers: {
      label: "定时器",
      constant: {
        label: "固定计时器",
        delay: "线程延迟(毫秒)"
      }
    },
    thread_groups: {
      label: "Threads（Users）",
      thread_group: {
        label: "Thread Group",
        on_sample_error: "在取样器错误后要执行的动作",
        continue: "继续",
        next_loop: "启动下一线程循环",
        stop_thread: "停止线程",
        stop_test: "停止测试",
        stop_test_now: "立即停止测试",
        thread: "线程属性",
        num_threads: "线程数",
        ramp_time: "Ramp-Up时间(秒)",
        loops: "循环数",
        forever: "无限循环",
        iteration: "每次迭代使用同一用户",
        delayed_start: "将线程创建延迟到需要时",
        scheduler: "调度器",
        duration: "持续时间(秒)",
        delay: "启动延迟(秒)",
      },
      setup_thread_group: {
        label: "setUp Thread Group"
      },
      post_thread_group: {
        label: "tearDown Thread Group"
      }
    },
    others: {
      test_plan: {
        label: "测试计划",
        variables: "用户自定义变量",
        name: "名称",
        value: "值",
        serialize: "独立运行每个线程组（例如在一个组结束后运行下一个 ）",
        tear_down: "主线程结束后运行tearDown线程组",
        functional: "函数测试模式",
      }
    },
  }
}
